<script setup lang="ts">
import { useNotificationStore } from '@/stores/notificationStore';
import Notification from './Notification.vue';

const notificationStore = useNotificationStore();

</script>

<template>
<TransitionGroup name="slideleft" tag="div" class="notifications-wrapper">
    <Notification
        v-for="{ id, type, text, duration } in notificationStore.notifications"
        :key="id"
        :type="type"
        :text="text"
        :duration="duration"
    />
</TransitionGroup>
</template>

<style lang="css">
@reference "@/assets/main.css";

@keyframes time-left {
    from {
        width: 100%;
    }
    to {
        width: 0%;
    }
}

.slideleft-enter-active,
.slideleft-leave-active {
    transition: all 0.5s ease-in-out;
}

.slideleft-enter-from,
.slideleft-leave-to {
    opacity: 0;
    transform: translateX(100%);
}

.slideleft-enter-to,
.slideleft-leave-from {
    opacity: 1;
    transform: translateX(0%);
}

.notifications-wrapper {
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    padding: 16px;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    position: fixed;
    pointer-events: none;
    z-index: 100000000;
}

.notification {
    @apply relative bg-white/60 rounded-[12px] backdrop-blur-[30px] p-4 border border-white/50 shadow-lg;
    pointer-events: auto;
}
.notification--success {
    border-left: 5px solid var(--color-success-400);
}
.notification--warning {
    border-left: 5px solid var(--color-warning-400);
}
.notification--success {
    border-left: 5px solid var(--color-success-400);
}
.notification--error {
    border-left: 5px solid var(--color-destructive-400);
}

.notification__time-indicator {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    height: 2px;
    animation-name: time-left;
    animation-timing-function: linear;
}
.notification--success .notification__time-indicator {
    background: var(--color-success-400);
}
.notification--error .notification__time-indicator {
    background: var(--color-destructive-400);
}

</style>